import { createContext, useState } from "react";

const product_card = [
  {
    id: 1,
    product_name: "2 Cruzeiros",
    description: "2 cruzeiros rara -  Ano 1945",
    price: 50,
    currency: "R$",
    thumb: "./images/1.png",
  },
  {
    id: 2,
    product_name: "10  Cruzeiros",
    description: "10 Cruzeiros - Ano 1965",
    price: 15,
    currency: "R$",
    thumb: "./images/10cruzeiros1965R15.png",
  },
  {
    id: 3,
    product_name: "20 Cruzeiros",
    description: "20 Cruzeiros - Ano 1965",
    price: 18,
    currency: "R$",
    thumb: "./images/20cruzeirs1965R18.png",
  },
  {
    id: 4,
    product_name: "200 Réis",
    description: "200 Réis - Ano 1895",
    price: 50,
    currency: "R$",
    thumb: "./images/200reis1896R50.png",
  },
  {
    id: 5,
    product_name: "500 Réis",
    description: "500 Réis - Ano 1939",
    price: 10,
    currency: "R$",
    thumb: "./images/500reis1939R8.png",
  },
  {
    id: 6,
    product_name: "50 Centavos",
    description: "50 Centavos - Ano 1943",
    price: 15,
    currency: "R$",
    thumb: "./images/50centavosCruzeirosRosa1943R6.png",
  },
  {
    id: 7,
    product_name: "10 Centavos",
    description: "10 Centavos - Ano 2016",
    price: 8,
    currency: "R$",
    thumb: "./images/10centavosReal2016R5.png",
  },
  {
    id: 8,
    product_name: "5 Centavos",
    description: "5 centavos - Ano 1998",
    price: 10,
    currency: "R$",
    thumb: "./images/5centavos-coroa.png",
  },
  {
    id: 9,
    product_name: "1  Centavo",
    description: "1 centavo - Ano 1999",
    price: 10,
    currency: "R$",
    thumb: "./images/1centavo-coroa.png",
  },
];

export const ProductsContext = createContext([]);

export const ProductsProvider = ({ children }) => {
  const [products] = useState(product_card);

  return (
    <ProductsContext.Provider value={{ products }}>
      {children}
    </ProductsContext.Provider>
  );
};
